var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 26,
    transform: "matrix(1 0 0 -1 26 26)",
    fill: "#F69606"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.8333 39.001H15.1667C14.5922 39.0003 14.0415 38.7718 13.6353 38.3656C13.2291 37.9595 13.0007 37.4087 13 36.8343V15.1676C13.0007 14.5932 13.2291 14.0425 13.6353 13.6363C14.0415 13.2301 14.5922 13.0016 15.1667 13.001H36.8333C37.4078 13.0016 37.9585 13.2301 38.3647 13.6363C38.7709 14.0425 38.9993 14.5932 39 15.1676V36.8343C38.9993 37.4087 38.7709 37.9595 38.3647 38.3656C37.9585 38.7718 37.4078 39.0003 36.8333 39.001ZM19.5 15.1676H15.1667V36.8343H19.5V15.1676ZM32.5 22.751H23.8333C23.546 22.751 23.2705 22.8651 23.0673 23.0683C22.8641 23.2714 22.75 23.547 22.75 23.8343C22.75 24.1216 22.8641 24.3972 23.0673 24.6003C23.2705 24.8035 23.546 24.9176 23.8333 24.9176H32.5C32.7873 24.9176 33.0629 24.8035 33.266 24.6003C33.4692 24.3972 33.5833 24.1216 33.5833 23.8343C33.5833 23.547 33.4692 23.2714 33.266 23.0683C33.0629 22.8651 32.7873 22.751 32.5 22.751ZM32.5 27.0843H23.8333C23.546 27.0843 23.2705 27.1984 23.0673 27.4016C22.8641 27.6048 22.75 27.8803 22.75 28.1676C22.75 28.455 22.8641 28.7305 23.0673 28.9337C23.2705 29.1368 23.546 29.251 23.8333 29.251H32.5C32.7873 29.251 33.0629 29.1368 33.266 28.9337C33.4692 28.7305 33.5833 28.455 33.5833 28.1676C33.5833 27.8803 33.4692 27.6048 33.266 27.4016C33.0629 27.1984 32.7873 27.0843 32.5 27.0843Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportLarge);
export default __webpack_public_path__ + "static/media/report-large.3dc1a1a5.svg";
export { ForwardRef as ReactComponent };